/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForRemediationTemplateExecutor extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForRemediationTemplateExecutor");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForRemediationTemplateExecutor.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForRemediationTemplateExecutor>): BackgroundJobPayloadForRemediationTemplateExecutor {
        let obj = Object.assign(new BackgroundJobPayloadForRemediationTemplateExecutor(), model);
        BackgroundJobPayloadForRemediationTemplateExecutor.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForRemediationTemplateExecutor>): BackgroundJobPayloadForRemediationTemplateExecutor {
        if (!model) return null;
        return BackgroundJobPayloadForRemediationTemplateExecutor.newInstance(<BackgroundJobPayloadForRemediationTemplateExecutor> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForRemediationTemplateExecutor) {
        if (!obj) return;

        models.BackgroundJobPayloadForRemediationTemplateExecutor.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForRemediationTemplateExecutor): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForRemediationTemplateExecutor.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * User ID
     */
    user_id: string;

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * request body from the api
     */
    req_body: string;

    /**
     * Recommendation ID
     */
    recommendation_id: string;

    /**
     * Action Resource ID
     */
    action_resource_id: string;

    /**
     * Recommendation Resource Objects
     */
    apply_resource_objects: string;

    /**
     * Recommendation Action Details
     */
    recommendation_action_details: string;

    /**
     * Key to check whether the request came from engine
     */
    is_engine: boolean;

    /**
     * Source
     */
    source: string;

}
